<template>
    <div class="card">
        <div class="card-body">
            <h5 class="card-title">Waypoint</h5>

            <form>
                <div class="form-group">
                    <label>
                        Name:
                    </label>
                    <input type="text" class="form-control" v-bind:class="{'is-invalid': wayPointErrors.name}"
                           name="name"
                           :value="wayPoint.name"
                           @input="onWayPointChange">
                    <div class="invalid-feedback" v-if="wayPointErrors.name">
                        {{wayPointErrors.name}}
                    </div>
                </div>
                <div class="form-group">
                    <label>
                        Location:
                    </label>
                    <input type="text" class="form-control" v-bind:class="{'is-invalid': wayPointErrors.location}"
                           name="location"
                           id="location"
                           ref="locationInput">
                    <div class="invalid-feedback" v-if="wayPointErrors.location">
                        {{wayPointErrors.location}}
                    </div>
                </div>
            </form>
            <a href="#" class="card-link"
                @click.prevent="add"> Add</a>
        </div>
    </div>
    
</template>

<script>

    import {isEmpty, MAX_ALLOWED_LENGTH} from "../../utils/commons";
    import {mapState} from "vuex";

    const initWayPointErrors = () => ({
        name: "",
        location: "",
        email: "",
    })

    export default {
        name: "AddWayPoint",
        data: () => {

            return {
                wayPointErrors: initWayPointErrors()
            }
        },
        props: {
            wayPoint: Object,
            updateWayPoint: Function,
            addWayPoint: Function,
        },
        computed: mapState({
            googleApi: state => state.globalStore.googleApi
        }),
        methods: {
            add: function(){

                let valid = true;

                this.wayPointErrors = initWayPointErrors();
                //Dodgy things
                const locationInput = this.$refs.locationInput;


                if(isEmpty(this.wayPoint.name) || this.wayPoint.name.length > MAX_ALLOWED_LENGTH) {
                    this.wayPointErrors.name = "Please enter valid name";
                    valid = false;
                }
                if(isEmpty(this.wayPoint.location.latLong && this.wayPoint.location.streetAddress)) {

                    //just for demo
                    if(!locationInput.value) {
                        this.wayPointErrors.location = "Please enter valid location";
                        valid = false;
                    }else {
                        this.updateWayPoint({name: "location", value: locationInput.value});
                    }
                }

                if(!valid){
                    return;
                }

                this.addWayPoint();

                locationInput.value = "";

            },
            onWayPointChange: function(event) {
                // eslint-disable-next-line no-console
                //console.log(event.target.name, event.target.value);

                this.updateWayPoint({name: event.target.name, value: event.target.value});

            },
            getLatLng(place) {
                try{

                    return place.geometry.location["lat"]()+","+place.geometry.location["lng"]();
                }
                catch (e) {
                    // eslint-disable-next-line no-console
                    console.error(e);
                    return "";
                }
            }
        }
        ,
        mounted() {
            const locationInput = this.$refs.locationInput;
            const locationAutoComplete = new this.googleApi.maps.places.Autocomplete(locationInput);
            locationAutoComplete.addListener("place_changed", () => {
                const place = locationAutoComplete.getPlace();
                const resultingLocation = this.getLatLng(place);
                this.updateWayPoint({name: "location", value: { latLong: resultingLocation, streetAddress: locationInput.value}});
            });
        }
    }
</script>

<style scoped>

</style>
